import React from 'react';
import GlobalLeaderboard from '../GlobalLeaderboard';
import { Typography, Paper, Skeleton } from '@mui/material';

import { useDashboardData } from './DashboardProvider';
import useTranslation from '../customHooks/translations';

const RankingsBox = () => {
  const { rankingsObject: rankings } = useDashboardData();
  const userRank = rankings.user?.rank;
  const isRankLoaded = rankings.user != null && userRank != null;
  const translation = useTranslation();
  return (
    <>
      <Paper sx={{
        borderRadius: '14px',
        background: 'linear-gradient(135deg, #0F766E 0%, #0D9488 40%, #14B8A6 100%)',
        padding: '1.25em 1em',
        textAlign: 'center',
        color: '#FFFFFF',
        lineHeight: '1.2em',
        marginBottom: '1.5em',
        border: 'none',
        boxShadow: '0 4px 16px rgba(13,148,136,0.2)',
      }}>
        <Typography component="h3" sx={{
          fontWeight: 800,
          paddingBottom: '8px',
          fontSize: '1.5em',
          color: '#FFFFFF',
          fontFamily: '"Outfit", "DM Sans", sans-serif',
        }}>
          {translation.rank} <br/>
          {isRankLoaded ? (
            <strong>{userRank}</strong>
          ) : (
            <Skeleton
              variant="text"
              width={48}
              sx={{
                mx: 'auto',
                bgcolor: 'rgba(255,255,255,0.35)',
                display: 'inline-block',
              }}
            />
          )}
        </Typography>
      </Paper>
      <GlobalLeaderboard />
    </>
  )
};

export default RankingsBox;
